export default __webpack_public_path__ + "static/media/seongdong-dolbom.41513eda.jpg";